export default __webpack_public_path__ + "static/media/480_dummy2016-personal01-de.d0ac15cc.png";